module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAtBAMAAABL8MaSAAAALVBMVEUAAAAeHh4XFxcZGRkaGhoZGRkaGhoYGBgZGRkaGhoZGRkZGRkZGRkZGRkZGRl/gMjeAAAADnRSTlMAESIzRGZ3iJmqu8zd7gKjCLQAAACISURBVCjPY2BgcUEABwYG1nvvEOBtAEPcO2TwlOHcizQE6HvD8G4CAxCwgLQyMHC+Y3iXAGKse/cKRLHB+CouTjB+C5J9HkA+KoCqhwK2Uf6g5y9DSg9ZQP6pVQiwBpd+5lUGMH4BiME0UwFEsQP5h5DU67xjmIeSPF4ySKPwNzIwZiHZt0wAAMkHv7ijg4ANAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/li-phone-black.png
// module id = 686
// module chunks = 0